<template>
  <div
    class="filter-selection"
    :class="{
      'has-active-filters': hasActiveFilters,
    }"
    @click="handleFilterClick"
  >
    <svg-icon class="filter-icon" name="Filter24" kind="action" />
    <div v-if="hasActiveFilters" class="filter-count" @click.stop.prevent="handleRemoveFilters">
      <span> {{ filterCount }} </span>
      <svg-icon class="remove" name="CrossTag16" kind="action" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Props
interface Props {
  filterCount?: number;
}

const { filterCount = 0 } = defineProps<Props>();

// Emits
const emit = defineEmits<{
  click: [];
  remove: [];
}>();

// Computed
const hasActiveFilters = computed(() => {
  return filterCount > 0;
});

// Methods
const handleFilterClick = () => {
  emit("click");
};

const handleRemoveFilters = () => {
  emit("remove");
};
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.filter-selection {
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: $hover-ui;
  }

  &.has-active-filters {
    padding-left: $spacing-05;
    background-color: $ui-03;
    border-radius: 10px;

    &:hover {
      background-color: $hover-selected-ui;
    }

    .filter-icon {
      [fill] {
        fill: $interactive-01;
      }
    }
  }

  .filter-count {
    @include carbon--type-style("helper-text-01");
    display: flex;
    align-items: center;
    margin: $spacing-03;
    padding: $spacing-02 $spacing-03;
    color: $text-04;
    background-color: $interactive-02;
    border-radius: 12px;

    .sls-icon {
      margin: 0 0 0 0.375rem;

      [fill] {
        fill: $ui-01;
      }
    }
  }
}
</style>
